import React, {Component, ReactNode} from "react";
import {MenuItem} from "@material-ui/core";
import SelectField, {SelectFieldProps} from "components/forms/SelectField";
import {Space, SpaceStatus} from "services/entities/spaces";
import {loadSpaces} from "services/spaces";
import {handleError} from "util/errors";

interface SpaceSelectorProps extends Omit<SelectFieldProps, 'children'> {
  onSpacesLoaded?:(spaces: Space[])=>void;
  emptyItem?:boolean|ReactNode;
}

interface SelectFieldState {
  spaces: Space[]|null;
}

export default class SpaceSelector extends Component<SpaceSelectorProps, SelectFieldState> {
  state: SelectFieldState = {
    spaces: null
  };

  componentDidMount(): void {
    loadSpaces().then(
      spaces => {
        this.setState({spaces: spaces.filter(sp => sp.status === SpaceStatus.Available)});
        if(this.props.onSpacesLoaded) {
          this.props.onSpacesLoaded(spaces);
        }
      },
      ex => handleError("Failed loading spaces", ex)
    );
  }

  render() {
    const spaces = this.state.spaces;
    const { emptyItem, ...fieldProps } = this.props;
    return <SelectField {...fieldProps}>
      { emptyItem === true && <MenuItem value="" /> }
      { emptyItem !== undefined && typeof(emptyItem) !== 'boolean' && <MenuItem value="">{ emptyItem }</MenuItem> }
      { spaces && spaces.map((space, index) => <MenuItem key={index} value={space.code}>{ space.name }</MenuItem>) }
    </SelectField>;
  }
}